import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const FORM_CONTROL_LABEL_TYPOGRAPHY_VARIANT = "body2Strong";

export const FormControlStyles = css(
    ({ theme }) => css`
        .FormControl {
            .FormControlLabelRoot {
                row-gap: ${theme.spacing[2]};
                .Label {
                    ${getTypographyStyle(FORM_CONTROL_LABEL_TYPOGRAPHY_VARIANT)}
                    color: ${theme.palette.text};
                }
            }

            .FormControlHint {
                margin-left: 0;
                ${getTypographyStyle("body4Medium")}
            }
        }
    `,
);
